import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c7d44d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "my-space",
  id: "env"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_box = _resolveComponent("map-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.spaceInfo)
      ? (_openBlock(), _createBlock(_component_map_box, {
          key: 0,
          class: "map-content",
          ref: "mapRef",
          onChangeSpaceId: _ctx.changeSpaceId,
          onDelPermanentSpace: _ctx.delPermanentSpace,
          isSetSpace: true,
          spaceInfo: _ctx.spaceInfo,
          projectId: _ctx.userInfo.projectId,
          id: "map"
        }, null, 8, ["onChangeSpaceId", "onDelPermanentSpace", "spaceInfo", "projectId"]))
      : _createCommentVNode("", true)
  ]))
}